<template>
  <div v-if="items">
    <v-combobox v-model="value.name" label="Name" :items="items.name" dense clearable @input="onInput" />
    <v-combobox v-model="value.lieu" label="Lieu" :items="items.lieu" dense clearable @input="onInput" />
    <v-combobox v-model="value.type" label="Type" :items="items.type" dense clearable @input="onInput" />
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config.js'

export default {
  name: "filters",
  components: {
  },
  props: {
    value: {
      type: Object,
      required: true,
    }
  },
  data: function() {
    return {
      items: null,
    }
  },
  async created() {
    this.items = {
      name: (await axios.get(`${config.apiUrl}/document?p=name`)).data,
      lieu: (await axios.get(`${config.apiUrl}/document?p=lieu`)).data,
      type: (await axios.get(`${config.apiUrl}/document?p=type`)).data,
    }
    this.$emit('input', {...this.$router.history.current.query} || {})
  },
  methods: {
    onInput: function() {
      const value = Object.fromEntries(Object.entries(this.value).filter(([, value]) => value))
      this.$router.replace({
        query: value,
      }).catch(() => {})
      this.$emit('input', value)
    }
  }
}
</script>
<style scoped>
</style>
